export default "__VITE_ASSET__BRKexwIg__"